import {useRef} from "react";

const useConstRef = (value) => useRef(value).current;

export default useConstRef;
